<p-modal-confirm
    [title]="'Error en la solicitud'"
    [icon]="'warning'"
    [subtitle]="'Por favor, contacte con un administrador.'"
    [isVisible]="true"
></p-modal-confirm>
